import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500 text-sm">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Cash verifiers can only access /cash-verification (and /profile).
  // Redirect everything else to /cash-verification.
  if (user.role === "CASH_VERIFIER") {
    if (roles && roles.includes("CASH_VERIFIER")) return children;
    return <Navigate to="/cash-verification" replace />;
  }
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}
